import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';

import { MwDirectivesModule } from '@core/directives/directives.module';

import { MwNewsApiService } from './@services/news-api.service';
import { MwNewsDataService } from './@services/news-data.service';
import { NewsEffects } from './@store/news.effect';
import { newsFeatureKey, newsReducer } from './@store/news.reducer';
import { MwNewsComponent } from './news.component';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    TranslateModule,
    MatListModule,
    MwDirectivesModule,
    StoreModule.forFeature(newsFeatureKey, newsReducer),
    EffectsModule.forFeature([NewsEffects]),
  ],
  declarations: [MwNewsComponent],
  exports: [MwNewsComponent],
  providers: [MwNewsDataService, MwNewsApiService],
})
export class MwNewsModule {}
